import { render, staticRenderFns } from "./login1.vue?vue&type=template&id=1d6fcd18&scoped=true"
import script from "./login1.vue?vue&type=script&lang=js"
export * from "./login1.vue?vue&type=script&lang=js"
import style0 from "./login1.vue?vue&type=style&index=0&id=1d6fcd18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6fcd18",
  null
  
)

export default component.exports